import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Entity } from '../Classes/EntityClass';
import 'rxjs/add/operator/map';
import { CommonSearch } from '../Classes/CommonClass';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class EntityService {
  constructor(private http: Http) { }

  ApiRootPath: string = "api/Entity/";

  GetEntitySearchResult(_CommonSearch: CommonSearch) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "SearchQuery": JSON.stringify(_CommonSearch.SearchQuery)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get(this.ApiRootPath + 'GetEntitySearchResult', options)
      .map((res: Response) => res.json());

  }


  GetAccExecutives(Mode: string, Tenantid: number, HotelId:string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let _mode = { "Mode": JSON.stringify(Mode), "TenantId": Tenantid, "Hotelid": JSON.stringify( HotelId)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: _mode });
    return this.http.get('api/Entity/GetUserDetails', options)
      .map((res: Response) => res.json());
  }

  GetBillingMonth(Tenantid: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let _mode = { "TenantId": Tenantid};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: _mode });
    return this.http.get('api/Entity/GetBillingMonthDetails', options)
      .map((res: Response) => res.json());
  }

  GetAccExecutivesForEntity(Mode: string, Tenantid: number, HotelId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let _mode = { "Mode": JSON.stringify(Mode), "TenantId": Tenantid, "Hotelid": JSON.stringify(HotelId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: _mode });
    return this.http.get('api/Entity/GetUserDetailsForEntity', options)
      .map((res: Response) => res.json());
  }

  GetLaborExportTypeFormatForEntity(Mode: string, Tenantid: number) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let _mode = { "Mode": JSON.stringify(Mode), "TenantId": Tenantid };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: _mode });
    return this.http.get('api/Entity/GetLaborExportTypeFormat', options)
      .map((res: Response) => res.json());
  }
  GetEditEntityDetails(TenantId: string,EntityId:string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = { "TenantId": JSON.stringify(TenantId), "EntityId": JSON.stringify(EntityId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Entity/GetEditEntityDetails', options)
      .map((res: Response) => res.json());
  }
  GetEditAppDetails(EntityId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = {  "EntityId": JSON.stringify(EntityId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Entity/GetEditAppDetails', options)
      .map((res: Response) => res.json());
  }

  GetSetFranchisebyHotelBrand(franchiseId: string, TenantId:string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = { "franchiseId": JSON.stringify(franchiseId), "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Entity/GetSetFranchisebyHotelBrand', options)
      .map((res: Response) => res.json());
  }

  GetEntitychangeLog(EntityID: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = { "EntityID": JSON.stringify(EntityID) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Entity/GetEntitychangeLog', options)
      .map((res: Response) => res.json());
  }

  GetFranDetails(tenantid: string,HotelName:string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = { "TenantId": JSON.stringify(tenantid), "HotelName": JSON.stringify(HotelName)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Entity/getFranchise', options)
      .map((res: Response) => res);
  }

  GetPMSSetting(_PMS_Setting: string) {
    let body: string = JSON.stringify(_PMS_Setting);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
       return this.http.get('api/Entity/getPMSSettTypeOne',options)
      .map((res: Response) => res.json());
  }

  GetEntryTypBYPmsSetting(SettingAppName: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "SettingAppName": JSON.stringify(SettingAppName.toString()) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get(this.ApiRootPath + 'getEntryType', options)
      .map((res: Response) => res.json());

  }

  //GetPMSSetting() {
  //  let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
  //  let options: RequestOptions = new RequestOptions({ headers: headers });
  //  return this.http.get('api/Organization/GetstateDetails', options)
  //    .map((res: Response) => res.json());
  //}


  SaveEntityDetails(_Entity: Entity) {
    let body: string = JSON.stringify(_Entity);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Entity/SaveEntityDetails', body, options)
      .map((res: Response) => res.json());
  }

  SaveAppName(data: any) {
    let body: string = JSON.stringify(data);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Entity/SaveAppName', body, options)
      .map((res: Response) => res.json());
  }

  SaveBrandName(data:any) {
    let body: string = JSON.stringify(data);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.post('api/Entity/SaveBrandName', body,options)
      .map((res: Response) => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/Services/EntityService.ts